import React, { useState, useEffect, useRef } from "react";
import { useParams, Link } from "react-router-dom";
import {
  Row,
  Col,
  Card,
  Badge,
  Button,
  Spinner,
  Overlay,
  Popover,
} from "react-bootstrap";
import { API_URL } from "../../../config";
import axios from "axios";
import moment from "moment";

const StartupGrantDetails = () => {
  const { grantId } = useParams();
  const [grant, setGrant] = useState(null);
  const [loading, setLoading] = useState(true);
  const [show, setShow] = useState(false);
  const [target, setTarget] = useState(null);
  const [copyMessage, setCopyMessage] = useState(false);
  const ref = useRef(null);

  const fetchGrantDetails = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${API_URL}/api/freshment_portal_apis/EduLearn/getGrantDetails`,
        {
          params: {
            id: grantId,
          },
        },
      );
      if (response.data.status) {
        setGrant(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching startup grant details:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchGrantDetails();
  }, [grantId]);

  const formatDate = (dateString) => {
    return moment(dateString).format("DD MMM, YYYY");
  };

  const handleClick = (event) => {
    setShow(!show);
    setTarget(event.target);
  };

  const copyLink = () => {
    const link = grant?.grant_apply_url;
    navigator.clipboard
      .writeText(link)
      .then(() => {
        setCopyMessage(true);
        setTimeout(() => {
          setCopyMessage(false);
        }, 2000);
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
      });
  };

  const shareOnFacebook = () => {
    const url = grant?.grant_apply_url;
    const message = grant?.name || "Check out this startup grant!";

    window.open(
      `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
        url,
      )}&quote=${encodeURIComponent(message)}`,
      "_blank",
    );
  };

  const shareOnWhatsApp = () => {
    const url = grant?.grant_apply_url;
    const message = grant?.name || "Check out this startup grant!";

    window.open(
      `https://api.whatsapp.com/send?text=${encodeURIComponent(
        message,
      )}%20${encodeURIComponent(url)}`,
      "_blank",
    );
  };

  const shareOnLinkedIn = () => {
    const url = grant?.grant_apply_url;
    window.open(
      `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
        url,
      )}`,
      "_blank",
    );
  };

  if (loading) {
    return (
      <div className="text-center py-5">
        <Spinner animation="border" variant="primary" />
        <p className="mt-2">Loading grant details...</p>
      </div>
    );
  }

  if (!grant) {
    return (
      <div className="text-center py-5">
        <h4>Grant not found</h4>
        <Link to="/startup-grants" className="btn btn-primary mt-3">
          Back to Grants
        </Link>
      </div>
    );
  }

  // Parse relevant industries from startup_theme if available
  const industries = grant.startup_theme
    ? grant.startup_theme
        .match(/[^,()]+(?:\([^)]*\))?/g)
        .map((item) => item.replace(/\.$/, "").trim())
        .filter(Boolean)
    : [];

  return (
    <div className="startup-grant-details">
      {/* Banner Section */}
      <div
        className="banner mb-4"
        style={{
          borderRadius: "10px",
          overflow: "hidden",
          position: "relative",
          background: "linear-gradient(135deg, #005dba 0%, #003a75 100%)",
          boxShadow: "0 10px 20px rgba(0,0,0,0.1)",
        }}
      >
        <div
          className="position-absolute"
          style={{ right: "5%", top: "10%", opacity: "0.05" }}
        >
          <i className="fas fa-lightbulb fa-5x text-white"></i>
        </div>
        <div
          className="position-absolute"
          style={{ left: "5%", bottom: "5%", opacity: "0.05" }}
        >
          <i className="fas fa-rocket fa-4x text-white"></i>
        </div>
        <div
          className="position-absolute"
          style={{ right: "15%", bottom: "15%", opacity: "0.05" }}
        >
          <i className="fas fa-chart-line fa-3x text-white"></i>
        </div>

        {/* Subtle pattern overlay */}
        <div
          className="position-absolute w-100 h-100"
          style={{
            top: 0,
            left: 0,
            backgroundImage:
              "radial-gradient(circle, rgba(255,255,255,0.1) 1px, transparent 1px)",
            backgroundSize: "20px 20px",
            opacity: 0.4,
          }}
        ></div>

        <div className="p-4 p-md-5">
          <Row className="align-items-center">
            <Col md={8}>
              <div className="d-flex align-items-center mb-3">
                {grant.organizer_image_url && (
                  <img
                    src={grant.organizer_image_url}
                    alt={grant.name}
                    className="me-3"
                    style={{
                      width: "60px",
                      height: "60px",
                      objectFit: "contain",
                      background: "white",
                      padding: "5px",
                      borderRadius: "5px",
                    }}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.style.display = "none";
                      const parentElement = e.target.parentNode;
                      const icon = document.createElement("i");
                      icon.className = "fa fa-building fa-2x text-white";
                      parentElement.appendChild(icon);
                    }}
                  />
                )}
                {/* {grant.image_url && (
                  <img
                    src={`${API_URL}/uploads/startup_grants/${grant.image_url}`}
                    alt={grant.name}
                    className="me-3"
                    style={{
                      width: "120px",
                      height: "auto",
                      objectFit: "contain",
                      background: "white",
                      padding: "5px",
                      borderRadius: "5px",
                    }}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.style.display = "none";
                    }}
                  />
                )} */}
              </div>

              <div className="text-center text-md-start mb-4">
                <h2
                  className="text-white mb-3 text-break"
                  style={{
                    whiteSpace: "break-spaces",
                    textShadow: "0 2px 4px rgba(0,0,0,0.2)",
                  }}
                >
                  {grant.name}
                </h2>

                {/* Themes moved to banner section */}
                {grant.startup_theme && industries.length > 0 && (
                  <div className="mb-3">
                    <div className="d-flex flex-wrap">
                      {industries.map((industry, index) => (
                        <div
                          key={index}
                          className="me-2 mb-2 py-1 px-3 rounded"
                          style={{
                            backgroundColor: "rgba(255, 255, 255, 0.2)",
                            backdropFilter: "blur(5px)",
                            fontSize: 13,
                            fontWeight: "500",
                            display: "inline-block",
                            color: "#fff",
                            border: "1px solid rgba(255, 255, 255, 0.3)",
                            boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
                          }}
                        >
                          {industry}
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>

              <div className="share-button-container">
                <div ref={ref}>
                  <button
                  
                    onClick={handleClick}
                    className="btn btn-sm btn-secondary position-relative"
                  >
                    <i className="fas fa-share-alt me-2"></i>
                    <span>Share</span>
                  </button>

                  <Overlay
                    show={show}
                    target={target}
                    placement="top-start"
                    container={ref.current}
                    rootClose={true}
                    onHide={() => setShow(false)}
                  >
                    <Popover
                      id="popover-basic"
                      className="popover-custom"
                      style={{ marginBottom: "10px", marginLeft: "10px" }}
                    >
                      <Popover.Content className="d-flex align-items-center p-3">
                        <div
                          onClick={copyLink}
                          className="copy-div fs-18 me-3 text-dark cursor-pointer"
                        >
                          <i className="fas fa-copy me-2 fs-18 icon-copy"></i>
                          Copy Link
                          {copyMessage && (
                            <span
                              style={{ zIndex: 10 }}
                              className="copy-message fade-in-out"
                            >
                              Link copied!
                            </span>
                          )}
                        </div>
                        <div
                          onClick={shareOnFacebook}
                          className="me-3 cursor-pointer"
                        >
                          <i className="fab fa-facebook-f me-2 fs-18 icon-facebook"></i>
                        </div>
                        <div
                          onClick={shareOnWhatsApp}
                          className="me-3 cursor-pointer"
                        >
                          <i className="fab fa-whatsapp me-2 fs-18 icon-whatsapp"></i>
                        </div>
                        <div
                          onClick={shareOnLinkedIn}
                          className="cursor-pointer"
                        >
                          <i className="fab fa-linkedin me-2 fs-18 icon-linkedin"></i>
                        </div>
                      </Popover.Content>
                    </Popover>
                  </Overlay>
                </div>
              </div>
            </Col>

            <Col md={4} className="mt-4 mt-md-0">
              <Card className="border-0 shadow">
                <Card.Body>
                  <h5 className="mb-3">Timeline</h5>

                  <div className="timeline-container position-relative pb-4">
                    <div
                      className="timeline-line position-absolute"
                      style={{
                        width: "2px",
                        backgroundColor: "#e9ecef",
                        left: "15px",
                        top: "10px",
                        bottom: "0",
                      }}
                    ></div>

                    <div className="d-flex mb-4 position-relative">
                      <div
                        className="timeline-icon rounded-circle bg-primary text-white d-flex align-items-center justify-content-center position-relative"
                        style={{ width: "32px", height: "32px", zIndex: "1" }}
                      >
                        <i className="fas fa-calendar-alt small"></i>
                      </div>
                      <div className="ms-3">
                        <div className="text-primary fw-bold">
                          {formatDate(grant.registration_start_date)}
                        </div>
                        <div className="text-muted small">
                          Application Start Date
                        </div>
                      </div>
                    </div>

                    <div className="d-flex mb-4 position-relative">
                      <div
                        className="timeline-icon rounded-circle bg-danger text-white d-flex align-items-center justify-content-center position-relative"
                        style={{ width: "32px", height: "32px", zIndex: "1" }}
                      >
                        <i className="fas fa-calendar-times small"></i>
                      </div>
                      <div className="ms-3">
                        <div className="text-danger fw-bold">
                          {formatDate(grant.registration_end_date)}
                        </div>
                        <div className="text-muted small">
                          Application End Date
                        </div>
                      </div>
                    </div>

                    {grant.event_date && (
                      <div className="d-flex position-relative">
                        <div
                          className="timeline-icon rounded-circle bg-success text-white d-flex align-items-center justify-content-center position-relative"
                          style={{ width: "32px", height: "32px", zIndex: "1" }}
                        >
                          <i className="fas fa-check small"></i>
                        </div>
                        <div className="ms-3">
                          <div className="text-success fw-bold">
                            {formatDate(grant.event_date)}
                          </div>
                          <div className="text-muted small">Event Date</div>
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="mt-3 text-center">
                    <Button
                      variant="primary btn-sm"
                      className="w-100"
                      href={grant.grant_apply_url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Apply Now
                    </Button>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </div>
      </div>

      {/* Program Title & Description */}
      <div className="mb-4">
        <h3 className="mb-3">{grant.name}</h3>
      </div>

      {/* Program Details */}
      <Row>
        <Col md={7}>
          <Card className="mb-4 h-auto">
            <Card.Body>
              <h4 className="mb-4">Program Details</h4>
              <div
                dangerouslySetInnerHTML={{
                  __html:
                    grant.description &&
                    grant.description
                      ?.replace(/\r\n/g, "<br />")
                      .replace(/\n/g, "<br />")
                      .replace(/\r/g, "<br />"),
                }}
              ></div>
            </Card.Body>
          </Card>
          {grant.eligibility_criteria && (
            <Card className="mb-4" style={{ height: "fit-content" }}>
              <Card.Body>
                <div className="mb-0">
                  <h4
                    className="text-uppercase mb-3"
                    style={{ fontSize: "16px", fontWeight: "600" }}
                  >
                    Eligibility Criteria
                  </h4>
                  <div
                    dangerouslySetInnerHTML={{
                      __html:
                        grant.eligibility_criteria &&
                        grant.eligibility_criteria
                          ?.replace(/\r\n/g, "<br />")
                          .replace(/\n/g, "<br />")
                          .replace(/\r/g, "<br />"),
                    }}
                  ></div>
                </div>
              </Card.Body>
            </Card>
          )}
        </Col>
        <Col md={5}>
          {/* {grant.image_url && (
            <img
              src={grant.image_url}
              alt={grant.name}
              className="img-fluid mb-4"
              style={{
                width: "100%",
                height: "auto",
                objectFit: "cover",
                background: "white",
                borderRadius: "10px",
              }}
              onError={(e) => {
                e.target.onerror = null;
                e.target.style.display = "none";
                const parentElement = e.target.parentNode;
                const icon = document.createElement("i");
                icon.className = "fa fa-building fa-2x text-primary";
                parentElement.appendChild(icon);
              }}
            />
          )} */}

          {/* Organizer Info */}
          <Card className="mb-4 h-auto">
            <Card.Body>
              <h4
                className="text-uppercase mb-3"
                style={{ fontSize: "16px", fontWeight: "600" }}
              >
                Organizer Information
              </h4>
              <div className="d-flex align-items-center mb-3">
                {grant.organizer_image_url && (
                  <img
                    src={grant.organizer_image_url}
                    alt={grant.organizer_name}
                    className="me-3"
                    style={{
                      width: "80px",
                      height: "80px",
                      objectFit: "contain",
                      background: "white",
                      padding: "5px",
                      borderRadius: "5px",
                      border: "1px solid #eee",
                    }}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.style.display = "none";
                    }}
                  />
                )}
                <div>
                  <h5>{grant.organizer_name}</h5>
                  {grant.organizer_website && (
                    <a
                      href={grant.organizer_website}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-primary"
                    >
                      <i className="fas fa-external-link-alt me-1"></i> Visit
                      Website
                    </a>
                  )}
                </div>
              </div>

              {grant.organizer_email && (
                <p>
                  <i className="fas fa-envelope me-2 text-primary"></i>{" "}
                  {grant.organizer_email}
                </p>
              )}
              {grant.organizer_phone && (
                <p>
                  <i className="fas fa-phone me-2 text-primary"></i>{" "}
                  {grant.organizer_phone}
                </p>
              )}
              {grant.location && (
                <p>
                  <i className="fas fa-map-marker-alt me-2 text-primary"></i>{" "}
                  {grant.location}
                </p>
              )}

              {grant.organizer_description && (
                <div className="mt-3">
                  <h5>About the Organizer</h5>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: grant.organizer_description,
                    }}
                  />
                </div>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <style jsx="true">{`
        .banner {
          display: flex;
          flex-direction: column;
          position: relative;
          min-height: 300px;
        }

        .banner-content {
          flex: 1;
          display: flex;
          flex-direction: column;
          position: relative;
        }

        .share-button-container {
          width: 100%;
          position: absolute;
          bottom: 16px;
          left: 16px;
        }

        @media (min-width: 768px) {
          .banner {
            min-height: 350px;
          }
        }

        @media (max-width: 767px) {
          .banner {
            padding-bottom: 60px;
          }
        }

        .popover-custom {
          border: none;
          border-radius: 10px;
          box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
          background-color: #fff;
        }
        .icon-copy {
          color: #007bff; /* Blue for copy link */
        }
        .icon-facebook {
          color: #4267b2; /* Facebook blue */
        }
        .icon-whatsapp {
          color: #25d366; /* WhatsApp green */
        }
        .icon-linkedin {
          color: #0077b5; /* LinkedIn blue */
        }
        .copy-div:hover {
          text-decoration: none;
          opacity: 0.8;
        }
        .copy-division {
          position: relative;
        }
        .cursor-pointer {
          cursor: pointer;
        }
        .copy-message {
          position: absolute;
          top: -30px; /* Adjust position above the icon */
          left: 10px;
          background-color: black;
          color: white;
          padding: 5px 8px;
          border-radius: 5px;
          font-size: 14px;
          white-space: nowrap; /* Prevent text wrap */
          opacity: 0; /* Start hidden */
          transition: opacity 0.5s ease;
        }
        .copy-message.fade-in-out {
          opacity: 1; /* Show the message */
        }
      `}</style>
    </div>
  );
};

export default StartupGrantDetails;
